module.exports = __webpack_public_path__ + "fonts/icomoon.d9dd8e0e5f12211b39b8ffa7f12e2730.ttf";